// Isolate the SDK-specific entrypoint here: bundling the recorder avoids failed external script loads without starting capture or creating another client (https://posthog.com/docs/libraries/js#installation).
import "posthog-js/dist/posthog-recorder";
